import { useTranslation } from "react-i18next";
import { CalendarDays, Coins, Bell, FileText, CalendarX, Timer, Ban } from "lucide-react";
import { Field } from "../../../components/neu/Field";
import { Toggle } from "./Toggle";
import { TriToggle } from "./TriToggle";

export const PayrollTab = ({ form, setNested }) => {
  const { t } = useTranslation();
  const p = form.payroll;

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      <Field
        label={t("branches.payrollDay")} testId="branch-payroll_day" type="number" min="1" max="31"
        value={p.payroll_day} onChange={(v) => setNested("payroll", "payroll_day", v)}
        accent="emerald" icon={CalendarDays}
      />
      <Field
        label={t("branches.currency")} testId="branch-payroll_currency"
        value={p.currency} onChange={(v) => setNested("payroll", "currency", v)}
        accent="amber" icon={Coins}
      />

      <div>
        <Field
          label={t("branches.noticeDays")} testId="branch-resignation_notice_days" type="number"
          value={p.resignation_notice_days} onChange={(v) => setNested("payroll", "resignation_notice_days", v)}
          accent="rose" icon={Bell}
        />
        <p className="mt-1 text-xs text-muted-foreground" data-testid="branch-notice-recommendation">
          {t("branches.noticeRecommended")}
        </p>
      </div>

      <div className="sm:col-span-2">
        <Field
          label={t("branches.endOfService")} testId="branch-end_of_service_note"
          value={p.end_of_service_note ?? ""} onChange={(v) => setNested("payroll", "end_of_service_note", v)}
          accent="violet" icon={FileText}
        />
      </div>

      <div className="sm:col-span-2">
        <TriToggle
          label={t("branches.allowEarlyAnnounce")} testId="branch-allow_early_announce"
          value={p.allow_early_announce ?? null}
          onChange={(v) => setNested("payroll", "allow_early_announce", v)}
        />
        <p className="mt-1 text-xs text-muted-foreground">{t("branches.allowEarlyAnnounceHint")}</p>
      </div>

      <div className="sm:col-span-2 pt-5">
        <p className="label-xs mb-3">{t("branches.deductionPolicy")}</p>
        <div className="grid gap-4 sm:grid-cols-2">
          <Toggle
            label={t("branches.deductAbsence")} testId="branch-deduct_absence"
            value={p.deduct_absence !== false} onChange={(v) => setNested("payroll", "deduct_absence", v)}
          />
          <Field
            label={t("branches.absenceDaysPerDay")} testId="branch-absence_days_per_day" type="number" step="any"
            value={p.absence_days_per_day ?? 1} onChange={(v) => setNested("payroll", "absence_days_per_day", Number(v))}
            disabled={p.deduct_absence === false} accent="orange" icon={CalendarX}
          />
          <Toggle
            label={t("branches.salaryHoldEnabled")} testId="branch-salary_hold_enabled"
            value={p.salary_hold_enabled !== false} onChange={(v) => setNested("payroll", "salary_hold_enabled", v)}
          />
          <Field
            label={t("branches.salaryHoldAbsenceDays")} testId="branch-salary_hold_absence_days" type="number" min="1" max="30"
            value={p.salary_hold_absence_days ?? 3} onChange={(v) => setNested("payroll", "salary_hold_absence_days", Number(v))}
            disabled={p.salary_hold_enabled === false} accent="rose" icon={Ban}
          />
          <Toggle
            label={t("branches.deductLate")} testId="branch-deduct_late"
            value={p.deduct_late !== false} onChange={(v) => setNested("payroll", "deduct_late", v)}
          />
          <Field
            label={t("branches.lateFreeMinutes")} testId="branch-late_free_minutes" type="number"
            value={p.late_free_minutes ?? 0} onChange={(v) => setNested("payroll", "late_free_minutes", Number(v))}
            disabled={p.deduct_late === false} accent="cyan" icon={Timer}
          />
        </div>
      </div>
    </div>
  );
};

